/**
 * 文章 api
 */
import { API_PREFIX } from '@shared/config';
import { httpClient } from '@shared/utils';
import { type ApiResult } from '../apis';

// 根据sourceId获取企业下文章id
export const getNewsIdApi = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/applet/news/find-news-id`, { params });
// 根据专题模板id获取专题id
export const getNewsSubjectIdApi = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/newsSubject/subjects/get_subject_id_by_template_id`, { params });
// 文章分类
export const getNewsTypeList = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.get(`${API_PREFIX}api/applet/news/type_list.do`, params);
// 文章列表
export const getNewsList = async <T, U>(params: T | any): Promise<ApiResult<U>> =>
  await httpClient.post(`${API_PREFIX}api/applet/news/list`, params);
